import React, { useState, useEffect } from 'react';

interface TabPanelProps {
	classNames: string;
	id: string;
	tabId: string;
	children?: React.ReactNode;
	getContent?: () => React.ReactNode;
	isHidden?: boolean;
}

const TabPanel: React.FC<TabPanelProps> = (props) => {
	const {
		classNames,
		id,
		tabId,
		children = undefined,
		getContent = undefined,
		isHidden = false,
	} = props;

	const [renderedAtLeastOnce, setRenderedAtLeastOnce] = useState(!isHidden);

	useEffect(() => {
		setRenderedAtLeastOnce(renderedAtLeastOnce || !isHidden);
	}, [renderedAtLeastOnce, isHidden]);

	return (
		<div
			aria-hidden={isHidden}
			aria-labelledby={tabId}
			className={classNames}
			id={id}
			role="tabpanel"
		>
			{getContent && renderedAtLeastOnce && getContent()}
			{!getContent && children}
		</div>
	);
};

export default TabPanel;
